(() => {
  "use strict";

  // ====================================================
  // TV PRODUCT GROUPS
  // ====================================================

  const FreeRipple = new Set([
    /*
    "prism-u55-ultra-qd-mini-led-4k-ai-google-tv",
    "prism-u65-ultra-qd-mini-led-4k-ai-google-tv",
    "prism-u75-ultra-qd-mini-led-4k-ai-google-tv",
    "prism-u86-ultra-qd-mini-led-4k-ai-google-tv",
    "prism-55al-google-tv",
    "prism-65al-google-tv"
    */
  ]);

  const FixedMount43to100 = new Set([
    /*
    "q43u-2026",
    "q55u-2026",
    "q65u-2026",
    "u55-2026",
    "u65-2026"
    */
  ]);

  const TiltedMount55to86 = new Set([
    /*
    "q75u-2026",
    "q85u-2026",
    "prism-q100-ultra-qled-google-tv",
    "u75-2026",
    "u75-qled-mini-led-google",
    "prism-u86-qd-mini-led"
    */
  ]);

  const QESeries = new Set([
    /*
    "q43qe-2026",
    "q55qe-2026",
    "q65qe-2026",
    "q75qe-2026",
    "s32-google-tv",
    "prism-s40-google-tv",
    "prism-s43-google-tv"
    */
  ]);

  const RoamSeries = new Set([
    "prism-roam-27",
    "prism-roam-ultra-27"
  ]);


  // ====================================================
  // MONITOR PRODUCT GROUPS
  // ====================================================

  const MonitorExclusivePriceDrops = new Set([
    "prism-pg25x-pro",
    "prism-pg27x-pro",
    "prism-pg27f-ultra",
    "prism-pg400u-pro",
    "prism-x490",
    "prism-x490-pro"
  ]);

  const MonitorUpsizedDiscounts = new Set([
    "prism-49al",
    "prism-49al-240hz"
  ]);


  // ====================================================
  // SALE LABELS
  // ====================================================

  const labels = {

    // TV
    FreeRipple:
      "9.9 SALE: Upsized Discount on Soundbar Bundles - Ends 14 Sep",

    FixedMount:
      "9.9 SALE: Upsized Discount on Soundbar Bundles - Ends 14 Sep",

    TiltedMount:
      "9.9 SALE: Upsized Discount on Soundbar Bundles - Ends 14 Sep",

    QESeries:
      "9.9 SALE: Upsized Discount on Soundbar Bundles - Ends 14 Sep",

    RoamSeries:
      "PAYDAY SALE: Upsized Discounts - Ends 27 Sep",

    // MONITORS
    MonitorExclusivePriceDrops:
      "PAYDAY SALE: Exclusive Price Drops - Ends 27 Sep",

    MonitorUpsizedDiscounts:
      "PAYDAY SALE: Upsized Discounts - Ends 27 Sep"

  };


  // ====================================================
  // UPDATE TV ITEM
  // ====================================================

  function updateTVItem(item) {

    const handle = item.getAttribute("data-product_handle");

    if (!handle) return;

    let labelText = null;

    if (FreeRipple.has(handle)) {

      labelText = labels.FreeRipple;

    } else if (FixedMount43to100.has(handle)) {

      labelText = labels.FixedMount;

    } else if (TiltedMount55to86.has(handle)) {

      labelText = labels.TiltedMount;

    } else if (QESeries.has(handle)) {

      labelText = labels.QESeries;

    } else if (RoamSeries.has(handle)) {

      labelText = labels.RoamSeries;

    }

    if (!labelText) return;


    let label = item.querySelector(".product-label");

    if (!label) {

      label = document.createElement("div");
      label.className = "product-label";

      const productImage = item.querySelector(".product-image");

      if (productImage) {
        productImage.before(label);
      } else {
        item.prepend(label);
      }

    }

    if (label.textContent !== labelText) {
      label.textContent = labelText;
    }

  }


  // ====================================================
  // UPDATE MONITOR ITEM
  // ====================================================

  function updateMonitorItem(item) {

    const handle = item.getAttribute("data-handle");

    if (!handle) return;

    let labelText = null;

    if (MonitorExclusivePriceDrops.has(handle)) {

      labelText = labels.MonitorExclusivePriceDrops;

    } else if (MonitorUpsizedDiscounts.has(handle)) {

      labelText = labels.MonitorUpsizedDiscounts;

    }

    if (!labelText) return;


    // Find existing:
    // <span class="v_tag one_lines">New Launch</span>

    let label = item.querySelector(".v_tag.one_lines");

    if (!label) {

      label = document.createElement("span");
      label.className = "v_tag one_lines";

      // Insert directly after the flash sale banner
      const flashSale = item.querySelector(
        ".pdpFlashSaleBnrWrap"
      );

      if (flashSale) {

        flashSale.after(label);

      } else {

        const gridItem = item.querySelector(".grid-view-item");

        if (gridItem) {
          gridItem.prepend(label);
        } else {
          item.prepend(label);
        }

      }

    }

    if (label.textContent !== labelText) {
      label.textContent = labelText;
    }

  }


  // ====================================================
  // PROCESS EXISTING PAGE
  // ====================================================

  function updateExistingItems() {

    document
      .querySelectorAll(".group-item[data-product_handle]")
      .forEach(updateTVItem);

    document
      .querySelectorAll(".v_hoverWrap[data-handle]")
      .forEach(updateMonitorItem);

  }


  // ====================================================
  // PROCESS NEW DOM NODE
  // ====================================================

  function processNode(node) {

    if (node.nodeType !== 1) return;


    // The node itself is a TV item
    if (node.matches(".group-item[data-product_handle]")) {
      updateTVItem(node);
    }


    // TV items inside the new node
    node
      .querySelectorAll?.(".group-item[data-product_handle]")
      .forEach(updateTVItem);


    // The node itself is a monitor
    if (node.matches(".v_hoverWrap[data-handle]")) {
      updateMonitorItem(node);
    }


    // Monitor items inside the new node
    node
      .querySelectorAll?.(".v_hoverWrap[data-handle]")
      .forEach(updateMonitorItem);

  }


  // ====================================================
  // INITIALIZE
  // ====================================================

  function init() {

    // Process products already rendered
    updateExistingItems();


    // Watch for newly rendered collection products
    const observer = new MutationObserver((mutations) => {

      mutations.forEach((mutation) => {

        mutation.addedNodes.forEach(processNode);

      });

    });


    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

  }


  // ====================================================
  // START
  // ====================================================

  if (document.readyState === "loading") {

    document.addEventListener(
      "DOMContentLoaded",
      init,
      { once: true }
    );

  } else {

    init();

  }

})();